import { render, staticRenderFns } from "./BatchGenerator.vue?vue&type=template&id=7810cc0a&scoped=true&"
import script from "./BatchGenerator.vue?vue&type=script&lang=ts&"
export * from "./BatchGenerator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810cc0a",
  null
  
)

export default component.exports